<template>
  <div :class="{'bottom-price-status-wrapper':discountPrice > 0 && locale==='hk'}">
    <div class="bottom-price-status">
      <div class="left-wrapper">
        <div v-if="fromPage==='unpaid-courses-list' && locale!=='hk'" class="enroll-tip">
          {{ $t('coursesDetail.enrollTip') }}
        </div>
        <div v-if="discountPrice > 0 && $t('coursesDetail.discountPrice')" class="discount-tip font-medium">
          {{ $t('coursesDetail.discountPrice') }}
        </div>
      </div>
      <div class="right-wrapper">
        <div class="price">
          <div
            v-show="priceModel=='discount'||priceModel=='noDiscount'"
          >
            <span v-if="locale==='sg'&&detailData.showPrice === 0&&detailData.showOrgPrice!==0" class="original-price">
              {{ currency }}{{ detailData.showOrgPrice | priceUnitConvert(minorUnit,isKeepTwoDecimal) }}
            </span>
            <span v-if="detailData.showOrgPrice==0" class="free-size font-semibold">{{ $t('coursesDetail.free') }}</span>
            <span v-else-if="isBM" class="present-price font-semibold">
              {{ currency }}{{ detailData.sellPrice | priceUnitConvert(minorUnit,isKeepTwoDecimal) }}/<span class="bm-lesson">lesson</span>
            </span>
            <span v-else-if="detailData.showPrice==0" class="present-price font-semibold">{{ $t('coursesDetail.free') }} </span>
            <span v-else-if="detailData.spec.leftLesson==0" class="present-price font-semibold">{{ $t('coursesDetail.free') }} </span>
            <template v-else-if="detailData.showPrice!=0">
              <div class="price-wrap">
                <div>
                  <span
                    v-show="priceModel=='discount'"
                    class="original-price font-semibold"
                  >{{ currency }} {{ (detailData.perOrgPrice||detailData.showOrgPrice)| priceUnitConvert(minorUnit, isKeepTwoDecimal) }}</span>
                  <span class="present-price font-semibold">{{ currency }}{{ sellPrice| priceUnitConvert(minorUnit, isKeepTwoDecimal) }} <span v-if="detailData.perShowPrice" class="per-lesson-text">{{ $t('courses.perLesson' ) }}</span> </span>
                </div>
                <div>
                  <!-- 价格展示是否含税 -->
                  <span v-if="(locale==='sg' || locale === 'uk')" class="price-tag tax-desc-tag font-semibold">
                    <template v-if="detailData.showPriceIsInclude">
                      {{ $t('common.taxExcluded') }}
                    </template>
                    <template v-else>
                      {{ $t('common.taxIncluded') }}
                    </template>
                  </span>
                  <!-- 价格展示不包含税费 美国分校 -->
                  <span v-if="(locale === 'us' || locale === 'cn' || locale === 'siliconvalley') && detailData.showPriceIsInclude === 1" class="price-tag tax-desc-tag font-semibold">
                    <template>Tax Excluded</template>
                  </span>
                  <!-- 价格包含课次数 -->
                  <span v-if="locale === 'hk'" class="price-tag sessions-tag font-semibold">
                    {{ $t('courses.lessonUnitTxt', [detailData.spec.leftLesson] ) }}
                  </span>
                </div>
              </div>
            </template>
          </div>

          <div v-show="priceModel=='free'" class="present-price free-size font-semibold">
            {{ $t('coursesDetail.free') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    detailData: {
      type: Object,
      default: () => ({}),
    },
    isBM: {
      default: false,
      type: Boolean,
    },
    isWish: {
      default: true,
      type: Boolean,
    },
    fromPage: {
      type: String,
      default: '',
    },
    priceModel: {
      default: '',
      type: String,
    },
    currency: {
      default: '',
      type: String,
    },
    minorUnit: {
      default: 0,
      type: Number,
    },
    signUpRemainTime: {
      default: 0,
      type: Number,
    },
    discountPrice: {
      default: 0,
      type: Number,
    },
    // discountList: {
    //   type: Array,
    //   default: () => ([]),
    // },
    priceAfterCoupon: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // operatedPrice: 0,
      isKeepTwoDecimal: this.$t('common.isKeepTwoDecimal'),
    }
  },
  computed: {
    sellPrice() {
      if (!this.detailData.showPrice) return ''
      if (this.detailData.perShowPrice !== undefined) return Number(this.detailData.perShowPrice)
      if (this.discountPrice > 0) return this.priceAfterCoupon
      return Number(this.detailData.showPrice)
    },
    locale() {
      return this.$store.state.locale
    },
    showPriceIsInclude() {
      return this.detailData.showPriceIsInclude === 0
    },
  },
}
</script>
<style lang="scss" scoped>
.bottom-price-status-wrapper {
  position: relative;
  margin-bottom: 68px;
}

.bottom-price-status {
  position: relative;
  z-index: 1;
  display: flex;
  padding: 11px 16px;
  min-height: 64px;
  background: #fff;
  overflow: hidden;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
}

.left-wrapper {
  display: flex;
  align-items: center;

  .enroll-tip {
    word-spacing: -2px;
    color: var(--txt-color-lv1);
    font-size: 16px;
    font-weight: 500;
  }

  .discount-tip {
    min-width: 115px;
    text-align: center;
    margin: 0 10px;
    padding: 0 10px;
    height: 24px;
    font-size: 12px;
    line-height: 24px;
    color: #fff;
    border-radius: 5px;
    background: var(--txt-color-link);
    display: none;
  }
}

.right-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.price {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  text-align: right;
  color: var(--txt-color-link);

  .original-price {
    margin-right: 4px;
    font-size: 12px;
    line-height: 16px;
    vertical-align: bottom;
    color: var(--txt-color-lv2);
    text-decoration: line-through;
  }

  .present-price {
    font-size: 20px;
    line-height: 24px;
    vertical-align: bottom;

    span.bm-lesson {
      font-size: 16px;
    }

    .per-lesson-text {
      margin-left: -3px;
      font-size: 12px;
      font-weight: 600;
      line-height: 14px;
    }
  }

  .price-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;

    .price-tag {
      display: inline-block;
      padding: 1px 4px;
      font-size: 12px;
      line-height: 14px;
      vertical-align: bottom;
      border-radius: 4px;
    }

    .tax-desc-tag {
      color: var(--txt-color-lv2);
      background-color: #f4f6fa;
    }

    .sessions-tag {
      color: var(--txt-color-link);
      background-color: var(--txt-color-link3);
    }
  }
}

.collect-icon {
  width: 52px;
  min-width: 52px;
  height: 52px;
  cursor: pointer;
}

.collect {
  background: url("~assets/images/courses/collect.png");
  background-size: cover;
}

.collected {
  background: url("~assets/images/courses/collected.png");
  background-size: cover;
}

</style>
